import React from 'react';
export function DescriptionSection() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 md:p-10 mb-12" data-id="element-1998">
      <div className="max-w-4xl mx-auto space-y-6 text-gray-700 text-lg leading-relaxed" data-id="element-1999">
        <p data-id="element-2000">
          We offer the largest selection of Wire EDMs in the market. CHMER EDM
          builds both ball screw drive as well as linear motor drive with glass
          scale closed loop feedback. They also offer both Flushing (F) or
          non-submerged wire EDMs, as well as submerged (S) types. All CHMER
          Wire EDMs have 6-axis CNC controls, so adding an integrated B-axis can
          be done at any time.
        </p>
        <p className="font-bold text-navy pt-2" data-id="element-2001">The models offered are:</p>
        <ul className="space-y-4" data-id="element-2002">
          <li className="flex items-start" data-id="element-2003">
            <span className="text-orange mr-3 font-bold" data-id="element-2004">-</span>
            <span data-id="element-2005">
              <strong className="text-navy" data-id="element-2006">G Series.</strong> Ball Screw with
              optional glass scales: G32F/S, G43F/S, G53F/S, G64F/S. Available
              in both Flushing (F) and Submerged (S) configurations.
            </span>
          </li>
          <li className="flex items-start" data-id="element-2007">
            <span className="text-orange mr-3 font-bold" data-id="element-2008">-</span>
            <span data-id="element-2009">
              <strong className="text-navy" data-id="element-2010">GLX Series.</strong> Linear motor
              drives: GLX 432, GLX 643.
            </span>
          </li>
          <li className="flex items-start" data-id="element-2011">
            <span className="text-orange mr-3 font-bold" data-id="element-2012">-</span>
            <span data-id="element-2013">
              <strong className="text-navy" data-id="element-2014">UA Series.</strong> High speed
              linear motor, CE Spec: UA432L, UA643L.
            </span>
          </li>
          <li className="flex items-start" data-id="element-2015">
            <span className="text-orange mr-3 font-bold" data-id="element-2016">-</span>
            <span data-id="element-2017">
              <strong className="text-navy" data-id="element-2018">RV Series.</strong> Linear motor,
              large travel gantry style with glass scales. Designed for large
              heavy parts where the work table is fixed and the wire moves in
              all axes: RV853L, RV855L, RV1065L, RV1285L.
            </span>
          </li>
        </ul>
      </div>
    </div>;
}